import { ReactComponent as DismissOtherIcon } from "src/assets/icons/close-WS.svg";
import { ReactComponent as DismissIcon } from "@preownedfront/lib-reowds/icons/24/dismiss.svg";
import { FC } from "react";
import { useNavigationLogic } from "../utils/useNavigationLogic";
import useResponsive from "src/utils/useResponsive";

interface DismissButtonProps extends React.SVGProps<SVGSVGElement> {
  ariaLabel: string;
  className?: string;
  onClick?: () => void;
  isSmall?: boolean;
}

export const DismissButton: FC<DismissButtonProps> = ({
  ariaLabel,
  className = "",
  isSmall = false,
  onClick,
  ...props
}) => {
  const { WSXS } = useResponsive();
  const { handleDimissClick } = useNavigationLogic();

  const iconClassName = WSXS ? "nav__icons__wm-icon__svg__close" : "nav__icons__header-icon__svg";
  const Icon = isSmall ? DismissIcon : DismissOtherIcon;
  return (
    <button
      onClick={onClick ? onClick : handleDimissClick}
      className={`nav-zds__icons__header-icon__button ${className}`}
      aria-label={ariaLabel}
    >
      <Icon
        className={iconClassName}
        {...props}
      />
    </button>
  );
};

export default DismissButton;
